import React from 'react'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'

import VehicleOptionsSelector from '../containers/VehicleOptionsSelector'

export default ({ vehicle, handleChange }) =>
  <form noValidate autoComplete="off">
    <Grid container>
      <Grid item xs={12}>
        <VehicleOptionsSelector year={vehicle.year} make={vehicle.make} model={vehicle.model} trim={vehicle.trim} handleChange={handleChange} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          id="vin"
          label="VIN"
          value={vehicle.vin}
          onChange={e => handleChange('vin', e.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          id="plate"
          label="License Plate"
          value={vehicle.plate}
          onChange={e => handleChange('plate', e.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
      {/* <Grid item xs={12}>
        <Button variant="raised" color="secondary">
          Add
          <Add />
        </Button>
      </Grid> */}
    </Grid>
  </form>


// WEBPACK FOOTER //
// ./src/modules/vehicles/components/VehiclesForm.js